import Vue from 'vue'

import Qs from 'qs'

class TicketRevenues {
  async indexTicket({ticketId, params}) {
    return await Vue.axios
      .get('app/ticket-revenues/by-ticket/' + ticketId, {
        params,
        paramsSerializer: (params) => {
          return Qs.stringify(params)
        }
      })
  }

  async createTicket({ticketId, data}) {
    return await Vue.axios
      .post('app/ticket-revenues/by-ticket/' + ticketId, data)
  }

  async read({id}) {
    return await Vue.axios
      .get('app/ticket-revenues/' + id)
  }

  async delete({id}) {
    return await Vue.axios
      .delete('app/ticket-revenues/' + id)
  }
}

const ticketRevenues = new TicketRevenues()

export default ticketRevenues
